export function safeStringify(value: any = null): string {
  return JSON.stringify(value).replace(/</g, '\\u003c');
}
